module.exports = __webpack_public_path__ + "static/media/professional.31439857.jpg";